import "../App.css";
import React, { useEffect, useState } from "react";
import ButtonLeft from "../assets/images/icons/Button_left.svg";
import { Box } from "@mui/material";
import ButtonRight from "../assets/images/icons/Button_right.svg";

function ColorCarousel({ data, sex, variant, type: propsType, action }) {
  const [loadedIcons, setLoadedIcons] = useState({});

  const [isMale, setSex] = useState(true);
  const [type, setType] = useState("");
  const [activeElement, setActiveElement] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [selectedColor, setSelectedColor] = useState(null);

  const handleIconLoad = (colorCode) => {
    setLoadedIcons((prevState) => ({ ...prevState, [colorCode]: true }));
  };

  useEffect(() => {
    setType(propsType);
    setSex(sex);
    const arrayTypes = [];
    data.forEach((item) => {
      const id = item.name[2] + item.name[3];
      if (!arrayTypes.find((x) => x.type == id)) {
        arrayTypes.push({ type: id, colors: [] });
      }
      const elem = arrayTypes.find((x) => x.type == id);
      if (elem != null) {
        const colorCode = item.name[5] + item.name[6];
        if (!elem.colors.includes(colorCode)) {
          elem.colors.push(colorCode);
        }
      }
    });
    let type = variant[7] + variant[8];
    if (sex === "female") {
      type = variant[9] + variant[10];
    }
    const element = arrayTypes.find((x) => x.type === type);
    if (element != null) {
      console.log(element);
      setActiveElement(element);
      setSelectedColor(type);
    }
  }, [data]);

  function getSexCode(isMale) {
    if (isMale === "male") {
      return "m";
    }
    if (isMale === "female") {
      return "f";
    }
  }

  function getTypeCode(type) {
    switch (type) {
      case "hair":
        return "h";
      case "facial_hair":
        return "f";
      default:
        return;
    }
  }
  const onChangeColor = (typeId, color) => {
    const data = `${getTypeCode(type)}${getSexCode(isMale)}${typeId}c${color}.png`;
    action(type, data);
    setSelectedColor(color);
  };

  const handlePrev = () => {
    setCurrentIndex(currentIndex === 0 ? activeElement.colors.length - 1 : currentIndex - 1);
  };

  const handleNext = () => {
    setCurrentIndex(currentIndex === activeElement.colors.length - 1 ? 0 : currentIndex + 1);
  };

  return (
    <Box id="CharacterCreator">
      <Box className="carousel__controls">
        <button onClick={handlePrev}>
          <img src={ButtonLeft} alt="" />
        </button>
        <button onClick={handleNext}>
          <img src={ButtonRight} alt="" />
        </button>
      </Box>
      <Box className="carousel">
        {activeElement
          ? activeElement.colors.map((color, index) => (
              <Box key={color} className={`carousel__icon-container ${index >= currentIndex && index < currentIndex + 3 ? "" : "hide"}`}>
                <img
                  className={`character-component ${loadedIcons[color] ? "" : "hidden"}`}
                  src={`https://storage.googleapis.com/anekdamian-site/preview/${type}/${isMale}/${getTypeCode(type)}${getSexCode(isMale)}${
                    activeElement.type
                  }c${color}.png`}
                  onClick={() => {
                    onChangeColor(activeElement.type, color);
                  }}
                  onLoad={() => handleIconLoad(color)}
                  style={{
                    border: color === selectedColor ? "2px solid #91ab87" : "none",
                    cursor: "pointer",
                    transition: "0.1s ease-in-out",
                  }}
                  alt="icon"
                />
              </Box>
            ))
          : ""}
      </Box>
    </Box>
  );
}

export default ColorCarousel;
